import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Col, FormGroup, Row } from "reactstrap";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "46%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#cad1d7", // Default border color
      },
      "&:hover fieldset": {
        borderColor: "#cad1d7", // Border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "#a7ce39", // Border color when focused
      },
    },
    "& .MuiOutlinedInput-input": {
      color: "#cad1d7", // Text color
    },
    "& .MuiInputLabel-outlined": {
      color: "#cad1d7", // Label color
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "#cad1d7", // Label color when focused
    },
    '& input[type="time"]::-webkit-calendar-picker-indicator': {
      filter: "invert(1)", // This inverts the color, making the icon white
    },
  },
}));

export default function TimePicker({
  handleDateRange,
  filtersData,
  lastUpdatedTimestamp,
}) {
  const classes = useStyles();
  const [timeRange, setTimeRange] = useState({
    start_time: "",
    end_time: "",
  });

  useEffect(() => {
    // Use UTC methods to prevent local time conversion
    const startTime = moment(filtersData.start_date).utc().format("HH:mm");
    const endTime = moment(filtersData.end_date).utc().format("HH:mm");

    console.log("startTime: ", startTime);
    console.log("endTime: ", endTime);

    setTimeRange({
      start_time: startTime,
      end_time: endTime,
    });
  }, [filtersData.start_date, filtersData.end_date]);

  const handleTimeChange = (event) => {
    const { id, value } = event.target;
    setTimeRange((prevState) => ({
      ...prevState,
      [id]: value,
    }));

    // Create moment objects using the local date from filtersData
    const startDate = moment(filtersData.start_date).utc();
    const endDate = moment(filtersData.end_date).utc();

    // Update the hours and minutes while preserving the date and timezone
    if (id === "start_time") {
      const [hours, minutes] = value.split(":");
      startDate.set({ hours, minutes });
    } else {
      const [hours, minutes] = value.split(":");
      endDate.set({ hours, minutes });
    }

    // Convert back to UTC for the backend
    handleDateRange(startDate, endDate);
  };

  return (
    <div
      id="reportrange"
      style={{
        cursor: "pointer",
        width: "100%",
      }}
    >
      <FormGroup className="mb-0">
        <Row className="justify-content-between">
          <Col xs={12} md={4}>
            <label className="form-control-label textWhite d-block filter-label-font-size">
              Start Time
            </label>
            <TextField
              id="start_time"
              type="time"
              size="small"
              value={timeRange.start_time}
              onChange={handleTimeChange}
              className={classes.root}
              inputProps={{
                step: 300, // 5 min
              }}
              variant="outlined"
              style={{ width: "100%" }}
            />
          </Col>

          <Col xs={12} md={4} className="d-none">
            <label className="form-control-label textWhite d-block filter-label-font-size">
              End Time
            </label>
            <TextField
              id="end_time"
              disabled
              type="time"
              size="small"
              value={timeRange.end_time}
              onChange={handleTimeChange}
              className={classes.root}
              inputProps={{
                step: 300, // 5 min
              }}
              variant="outlined"
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={12} md={4} className="mt-4">
            <span className="h3 text-muted mr-3">Last Updated Time :</span>
            <span className="h2 text-muted">
              {moment(lastUpdatedTimestamp).utc().format("DD-MM-YYYY HH:mm")}
            </span>
          </Col>
        </Row>
      </FormGroup>
    </div>
  );
}
